import { render } from "./DragQuestion.vue?vue&type=template&id=231f2cc0&scoped=true&ts=true"
import script from "./DragQuestion.vue?vue&type=script&lang=ts"
export * from "./DragQuestion.vue?vue&type=script&lang=ts"

import "./DragQuestion.vue?vue&type=style&index=0&id=231f2cc0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231f2cc0"]])

export default __exports__